import { render, staticRenderFns } from "./DmDashManagerShortcut.vue?vue&type=template&id=68938b16&scoped=true&"
import script from "./DmDashManagerShortcut.vue?vue&type=script&lang=js&"
export * from "./DmDashManagerShortcut.vue?vue&type=script&lang=js&"
import style0 from "./DmDashManagerShortcut.vue?vue&type=style&index=0&id=68938b16&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68938b16",
  null
  
)

export default component.exports